import Axios from "axios";
import { baseURL } from "../axios";
import * as auth from "./auth";

const url = baseURL;

export const customerLogin = (contact: number, pwd: string, rememberMe?: boolean,deviceId ?: string,latitude ?: any,longitude ?: any) => {
  const flag : any = {
    username: contact,
    password: pwd,
    rememberMe : rememberMe,
  };
  if(deviceId){
    flag.deviceId = deviceId;
  }
  if(latitude){
    flag.latitude = latitude;
  }
  if(longitude){
    flag.longitude = longitude;
  }
  return async (dispatch: any) => {
    try {
      dispatch({
        type: "START_LOADER",
      });
      let response = await Axios({
        method: "post",
        url: url + "/customerLogin",
        data: flag,
      });
      console.log("customer login response", response);
      dispatch({
        type: "CUSTOMER_LOGIN",
        payload: response.data.response,
      });
      sessionStorage.setItem("IsCustomer",true as any)
      await dispatch(auth.registerSocket({ token: response.data.response.accessToken }))
      dispatch({
        type: "END_LOADER",
      });
    } catch (err : any) {
      console.log(err);
      if (err.response) {
        dispatch({
          type: "LOGIN_FAIL",
          payload:
            err.response.data.message === "Invalid or expired otp."
              ? err.response.data.message
              : "Invalid credentials!",
        });
      } else if (err.request) {
        dispatch({
          type: "LOGIN_FAIL",
          payload:
            err.message == "Network Error" ? "No Internet!" : err.message,
        });
      } else {
        dispatch({
          type: "LOGIN_FAIL",
          payload: err.message,
        });
      }
      dispatch({
        type: "END_LOADER",
      });
    }
  };
};

export const addressSuggestionAction = (data: any) => {
  console.log(data, "data from 001")
  return {
    type: "SET_CUSTOMER__ADDRESS_SUGGESTION_DETAILS",
    data
  }
}

export const friendAddressSuggestionAction = (data: any) => {
  console.log(data, "data from 001")
  return {
    type: "SET_CUSTOMER__FRIEND_ADDRESS_SUGGESTION_DETAILS",
    data
  }
}

export const customerLogoutReducer = () => { return { type: "CUSTOMER_LOGOUT" } }

export const customerLoginWithToken = (token : any) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: "START_LOADER",
      });
      let response = await Axios({
        method: "post",
        url: url + "/customerToken/getIdToken",
        data: {rt : token},
      });
      console.log("customerLoginWithToken customer login response 96000", response);
      dispatch({
        type: "CUSTOMER_LOGIN",
        payload: response?.data?.response,
      });
      dispatch({
        type: "END_LOADER",
      });
    } catch (err : any) {
      console.log(err);
      dispatch({
        type: "END_LOADER",
      });
    }
  };
};

export const setCustomerDetails = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: "START_LOADER",
      });
      let response = await Axios({
        method: "get",
        url: url + "/customerProfile/getDetails",
      });
      console.log("SET_CUSTOMER_DETAILS customer login response 96000", response);
      dispatch({
        type: "SET_CUSTOMER_DETAILS",
        payload: response?.data?.response,
      });
      dispatch({
        type: "END_LOADER",
      });
    } catch (err : any) {
      console.log(err);
      dispatch({
        type: "END_LOADER",
      });
    }
  };
}